$(document).ready(function () {
  $('.ch-bundle-item').each(function () {
    const $container = $(this);

    const variant4pack   = $container.data('variant-4pack');
    const price4pack     = parseInt($container.data('price-4pack'));
    const compare4pack   = parseInt($container.data('compare-4pack'));

    const variant12pack  = $container.data('variant-12pack');
    const price12pack    = parseInt($container.data('price-12pack'));
    const compare12pack  = parseInt($container.data('compare-12pack'));

    const $addToCartBtn  = $container.parents('.product-information').find('[ref="addToCartButtonContainer"] button');
    const $hiddenWrap    = $container.parents('.product-information').find('.hidden-item');
    const $productForm   = $container.parents('.product-information').find('form[action*="/cart/add"], form.product-form, form[data-type="add-to-cart-form"]');
    const $bundleInputs  = $container.find('.bundle_item');
    const $flavourCards  = $container.find('.flavour-card');

    let selectedPack          = '4pack';
    let currentVariantId      = variant4pack;
    let currentBasePrice      = price4pack;
    let currentComparePrice   = compare4pack;
    let currentPlanPrice      = price4pack;
    let currentSellingPlan    = null;
    let currentDiscountPct    = 0;
    let maxQty                = parseInt($bundleInputs.filter(':checked').val()) || 4;
    let currentBundleQuantity = maxQty;

    $addToCartBtn.prop('disabled', true);

    // ============================================================
    // BADGE TOGGLE — OTP ho to hide, subscription ho to show
    // ============================================================
    function updateBadges() {
      const $badges = $container.find('.wd-discount-badge');
      if (currentSellingPlan === null || currentSellingPlan === '') {
        $badges.hide();
      } else {
        $badges.show();
      }
    }

    // ============================================================
    // NUKE ALL SELLING PLAN INPUTS
    // ============================================================
    function nukeAllSellingPlanInputs() {
      $hiddenWrap.find('input[name="selling_plan"]').remove();
      if ($productForm.length) {
        $productForm.find('input[name="selling_plan"]').remove();
        $productForm.find('select[name="selling_plan"]').val('');
      }
      $('form[action*="/cart/add"] input[name="selling_plan"]').remove();
    }

    // ============================================================
    // SET DEFAULT SUBSCRIPTION
    // ============================================================
    function setDefaultSubscription() {
      const planClass     = selectedPack === '4pack' ? '.selling_plan_4pack' : '.selling_plan_12pack';
      const $firstSubPlan = $container.find(planClass).filter(function () {
        return $(this).val() !== '';
      }).first();

      if ($firstSubPlan.length) {
        $firstSubPlan.prop('checked', true);
        currentSellingPlan = $firstSubPlan.val();
        currentPlanPrice   = parseInt($firstSubPlan.data('plan-price')) || currentBasePrice;
        currentDiscountPct = currentBasePrice > 0
          ? Math.round((1 - currentPlanPrice / currentBasePrice) * 100)
          : 0;
      }
    }

    // ============================================================
    // BUNDLE BOX CHANGE
    // ============================================================
    $bundleInputs.on('change', function () {
      const $input = $(this);
      selectedPack = $input.data('pack');
      maxQty       = parseInt($input.val()) || 4;
      currentBundleQuantity = maxQty;

      if (selectedPack === '4pack') {
        currentVariantId    = variant4pack;
        currentBasePrice    = price4pack;
        currentComparePrice = compare4pack;
      } else {
        currentVariantId    = variant12pack;
        currentBasePrice    = price12pack;
        currentComparePrice = compare12pack;
      }

      $container.find('.subscription-plans[data-plans-for="4pack"]').toggle(selectedPack === '4pack');
      $container.find('.subscription-plans[data-plans-for="12pack"]').toggle(selectedPack === '12pack');

      setDefaultSubscription();
      resetBundle();
      updateAllPrices();
      updateBadges();
    });

    // ============================================================
    // PLAN CHANGE
    // ============================================================
    $container.on('change', '.selling_plan_4pack, .selling_plan_12pack', function () {
      const val = $(this).val();

      if (val === '' || val === null || val === undefined) {
        currentSellingPlan = null;
        currentPlanPrice   = currentBasePrice;
        currentDiscountPct = 0;
      } else {
        currentSellingPlan = val;
        currentPlanPrice   = parseInt($(this).data('plan-price')) || currentBasePrice;
        currentDiscountPct = currentBasePrice > 0
          ? Math.round((1 - currentPlanPrice / currentBasePrice) * 100)
          : 0;
      }

      updateAllPrices();
      updateBadges();
      updateHiddenItems();
    });

    // ============================================================
    // PRICE UPDATE — DONO BOXES
    // ============================================================
    function updateAllPrices() {
      $bundleInputs.each(function () {
        const $input      = $(this);
        const pack        = $input.data('pack');
        const boxDiscount = parseFloat($input.data('discount')) || 0;
        const boxQuantity = parseInt($input.data('quantity')) || 1;

        const basePrice    = pack === '4pack' ? price4pack : price12pack;
        const comparePrice = pack === '4pack' ? compare4pack : compare12pack;

        let planPrice;
        if (currentDiscountPct > 0) {
          planPrice = Math.round(basePrice * (1 - currentDiscountPct / 100));
        } else {
          planPrice = basePrice;
        }

        const finalPrice   = Math.round(planPrice - (planPrice * boxDiscount / 100));
        const pricePerUnit = Math.floor(finalPrice / boxQuantity);

        const $box     = $input.closest('.ch-bundle-box-label');
        const $compare = $box.find('.wd-original-price');

        $box.find('[data-price-display][data-pack="' + pack + '"]').text(formatMoney(finalPrice));
        $box.find('[data-unit-price][data-pack="' + pack + '"]').text(formatMoney(pricePerUnit) + ' / unit');

        // FIX: hamesha comparePrice dikhao — OTP ho ya subscription
        // comparePrice product ki original compare_at_price hai
        if (comparePrice > finalPrice) {
          $compare.text(formatMoney(comparePrice)).css('text-decoration', 'line-through').show();
        } else {
          $compare.text('').hide();
        }
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // ============================================================
    // FLAVOUR PLUS
    // ============================================================
    $container.on('click', '.flavour-plus', function () {
      const $card = $(this).closest('.flavour-card');
      if (getTotalQuantity() >= maxQty) return;
      $card.find('.quantity-input').val(1);
      toggleUI($card, 1);
      updateHiddenItems();
    });

    // ============================================================
    // QUANTITY +/-
    // ============================================================
    $container.on('click', '.quantity-btn', function () {
      const $card  = $(this).closest('.flavour-card');
      const $input = $card.find('.quantity-input');
      let val      = parseInt($input.val()) || 0;

      if ($(this).hasClass('plus')) {
        if (getTotalQuantity() >= maxQty) return;
        val++;
      } else {
        val = Math.max(0, val - 1);
      }

      $input.val(val);
      toggleUI($card, val);
      updateHiddenItems();
    });

    function toggleUI($card, val) {
      if (val === 0) {
        $card.find('.flavour-quantity').hide();
        $card.find('.flavour-plus').show();
      } else {
        $card.find('.flavour-quantity').css('display', 'flex');
        $card.find('.flavour-plus').hide();
      }
    }

    function getTotalQuantity() {
      let total = 0;
      $container.find('.quantity-input').each(function () {
        total += parseInt($(this).val()) || 0;
      });
      return total;
    }

    // ============================================================
    // UPDATE HIDDEN INPUTS
    // ============================================================
    function updateHiddenItems() {
      nukeAllSellingPlanInputs();
      $hiddenWrap.empty();

      let totalQty = 0;
      let flavours = [];

      $flavourCards.each(function () {
        const qty = parseInt($(this).find('.quantity-input').val()) || 0;
        if (qty > 0) {
          totalQty += qty;
          flavours.push({ title: $(this).data('product-title'), qty });
        }
      });

      if (totalQty === maxQty && flavours.length) {

        $hiddenWrap.append(
          $('<input>', { type: 'hidden', name: 'id',       value: currentVariantId }),
          $('<input>', { type: 'hidden', name: 'quantity', value: 1 })
        );

        if (currentSellingPlan !== null && currentSellingPlan !== '' && currentSellingPlan !== undefined) {
          $hiddenWrap.append(
            $('<input>', { type: 'hidden', name: 'selling_plan', value: currentSellingPlan })
          );
        }

        $hiddenWrap.append(
          $('<input>', { type: 'hidden', name: 'properties[Bundle Size]', value: currentBundleQuantity + ' units' })
        );

        flavours.forEach(function (f, i) {
          $hiddenWrap.append(
            $('<input>', { type: 'hidden', name: 'properties[Product type ' + (i + 1) + ']', value: f.title + ' (x' + f.qty + ')' })
          );
        });

        $hiddenWrap.append(
          $('<input>', { type: 'hidden', name: 'properties[Bundle Contents]', value: flavours.map(function (f) { return f.qty + 'x ' + f.title; }).join(', ') }),
          $('<input>', { type: 'hidden', name: 'properties[_bundle]', value: 'true' })
        );
      }

      $addToCartBtn.prop('disabled', totalQty !== maxQty);

      const maxReached = totalQty >= maxQty;
      $container.find('.flavour-plus, .quantity-btn.plus')
        .prop('disabled', maxReached)
        .css('opacity', maxReached ? 0.3 : 1);
    }

    // ============================================================
    // ATC INTERCEPT
    // ============================================================
    $addToCartBtn.on('click', function () {
      if (currentSellingPlan === null || currentSellingPlan === '') {
        nukeAllSellingPlanInputs();
      }
    });

    // ============================================================
    // RESET
    // ============================================================
    function resetBundle() {
      $container.find('.quantity-input').val(0);
      $container.find('.flavour-quantity').hide();
      $container.find('.flavour-plus').show().prop('disabled', false).css('opacity', 1);
      $hiddenWrap.empty();
      $addToCartBtn.prop('disabled', true);
    }

    // ============================================================
    // START
    // ============================================================
    setDefaultSubscription();
    updateAllPrices();
    updateBadges();
    updateHiddenItems();

  });
});